import { useEffect, useState } from "react";
import { Flex, SimpleGrid, Text, useToast } from "@chakra-ui/react";
import { search } from 'ss-search';
import Quagga from '@ericblade/quagga2';

import api from "../../services/api";
import useDebounce from "../../utils/useDebounce";
import { formatPrice } from "../../utils/format";
import Header from "../../components/Header";
import { Item } from "../../components/Cardapio/Item";
import ModalItem from "../../components/Cardapio/ModaItem";
import Cart from "../../components/Cart";
import Loading from "../../components/Loading";
import MenuClassif from "../../components/Cardapio/MenuClassif";
import ModalScanner from "../../components/ModalScanner";
import { AppError } from "../../utils/AppError";

type ProdutoData = {
	id: string;
	categoria: string;
	cod_barras: string;
	cod_pro: string;
	comiss_ind: number;
	comiss_ven: number;
	complementos: ComplementoData[];
	descricao: string;
	nome: string;
	obs: string;
	promocao: string;
	qtd: number;
	total: number;
	url_imagem: string;
	valor: number;
	valorFormatted: string;
}
type ComplementoData = {
	codigo: number;
	grupo: number;
	nome: string;
	descricao: string;
	custo: number;
	valor: number;
	priceFormatted: string;
	qtd_maxima: number;
	qtd_gratis: number;
	qtd: number;
}
type ClassificacaoData = {
	CODCLA: number;
	CODSCL: number;
	nome: string;
}

const Produtos: React.FC = () => {
  const toast = useToast();

	const [loading, setLoading] = useState(true);

	const [produtos, setProdutos] = useState<ProdutoData[]>([]);
	const [searchProducts, setSearchProducts] = useState<ProdutoData[]>([]);
	const [classifs, setClassifs] = useState<ClassificacaoData[]>([]);

	const [isOpenCart, setIsOpenCart] = useState(false);

	const [isOpenModalItem, setIsOpenModalItem] = useState(false);
	const [produtoItemModal, setProdutoItemModal] = useState<ProdutoData>({} as ProdutoData);
	const [isAddNewItem, setIsAddNewItem] = useState(true);

	const [classifSelect, setClassifSelect] = useState<ClassificacaoData>({} as ClassificacaoData);
  const [classifRecovery, setClassifRecovery] = useState<ClassificacaoData>({} as ClassificacaoData);

	const [isOpenModalScanner, setIsOpenModalScanner] = useState(false);

	const [device, setDevice] = useState('');
  const [devices, setDevices] = useState<any[]>([]);
	const [isVisibleBtnScanner, setIsVisibleBtnScanner] = useState(false);

  const idToast = 'test-toast';

  async function fetchAllProducts() {
    try {
      const { data } = await api.get('controle/produto');
      const { itens, classificacao } = data;

      const aux = [] as ProdutoData[];

      const products = itens.map((product: ProdutoData) => {
        if (product.categoria === classificacao[0].nome)
          aux.push(product);

        return {
          ...product,
          valorFormatted: formatPrice(product.valor)
        }
      });

      setProdutos(products);
      setSearchProducts(aux);

      setClassifs(classificacao);
      setClassifSelect(classificacao[0]);
      setClassifRecovery(classificacao[0]);
			
    } catch (error) {
      const isAppError = error instanceof AppError;
      const description = isAppError ? error.message : 'Não foi possível buscar os produtos.';

      toast({
        title: 'Busca por produtos falhou.',
        description,
        status: 'error',
        duration: 5000,
        position: 'top-right',
        isClosable: true,
      });
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // setLoading(true);
    Quagga.CameraAccess.enumerateVideoDevices().then((devicess) => {
      // setDevice(devicess[devicess.length - 1].deviceId);
      // const auxDevices: any[] = devices;

      /* devicess.map((devicee: any) => {
        // auxDevices.push(device.deviceId);
        const indexDevice = auxDevices.findIndex(item => item.id === devicee.id);

        if (indexDevice === -1)
          auxDevices.push(device);
      });*/


      // if (auxDevices.length > 0) {
      if (devicess.length > 0) {
        // setDevice(auxDevices[auxDevices.length - 1].deviceId);
        // setDevices(auxDevices);
        setDevice(devicess[devicess.length - 1].deviceId);
        setDevices(devicess);
      }

      setIsVisibleBtnScanner(devicess.length > 0);
    });

    fetchAllProducts();
  }, []);

	async function handleSearchClassif(event: string) {
    const resultProducts = produtos.filter((produto) => produto.categoria === event);
		setSearchProducts(resultProducts);
	};

	async function handleSearchProduct(text: string) {
    setClassifSelect({} as ClassificacaoData);

		if (text === '' || text === undefined || text === null) {
			await handleSearchClassif(classifRecovery.nome);
      setClassifSelect(classifRecovery);
			return;
		};

    const searchKeys = ['nome', 'categoria', 'cod_barras', 'descricao'];
    const resultsProducts = search(produtos, searchKeys, text) as ProdutoData[];
		setSearchProducts(resultsProducts);
	};

	const debounceChange = useDebounce(handleSearchProduct, 1000);

  async function handleCode(code: string): Promise<boolean> {
    const prod = produtos.find(product => product.cod_barras === code) as ProdutoData;

    if (prod) {
      setProdutoItemModal(prod);
      setIsAddNewItem(true);
      setIsOpenModalItem(true);
      return true;
    } else {
      if (!toast.isActive(idToast)) {
        toast.closeAll();
        toast({
          id: idToast,
          title: 'Scanner.',
          description: `Erro na leitura do código de barras ou\nProduto com este código não existe.`,
          status: 'error',
          duration: 3000,
          position: 'top-right',
          isClosable: true,
        });
      }

      return false;
    }
  };

	return (
		<>
			{isOpenModalScanner && (
				<ModalScanner
					onRequestClose={setIsOpenModalScanner}
					handleCode={handleCode}
					device={device}
          devices={devices}
				/>
			)}

			<Flex
				w="100vw"
				h="100vh"
				flexDir="column"
				align="center"
				overflowX="hidden"
			>
				<Header
					isOpenCart={setIsOpenCart}
					handleSearchProduct={debounceChange}
					setIsOpenScanner={setIsOpenModalScanner}
					isOpenScanner={isOpenModalScanner}
					isVisibleBtnScanner={isVisibleBtnScanner}
				/>

				{loading ? (
					<Loading />
				) : (
					<Flex
						align="center"
						flexDir="column"
						mt={["88px", "110px", "110px", "65px"]}
						px={["4", "4", "20", "24"]}
					>
						<MenuClassif
							classificacoes={classifs}
							selectedClassif={classifSelect}
							setSelectedClassif={setClassifSelect}
              setRecoveryClassif={setClassifRecovery}
							handleSearchClassif={handleSearchClassif}
						/>

            {/* <Flex marginTop={20} flexDir="column">
              {devices.map(device => (
                <Flex
                  flexDir="column"
                  p={1}
                  key={device.deviceId}
                  borderWidth={1}
                  borderColor="black"
                  borderRadius={10}
                >
                  <Text color="blue.500" fontSize={9}>
                    {device.deviceId}
                  </Text>
                  <Text color="blue.500" fontSize={9}>
                    {device.groupId}
                  </Text>
                  <Text color="blue.500" fontSize={9}>
                    {device.kind}
                  </Text>
                  <Text color="blue.500" fontSize={9}>
                    {device.label}
                  </Text>
                </Flex>
              ))}
              </Flex> */}

						{/* CLASSIFICAÇÃO TITULO */}
						<Flex
							w="100%"
							alignItems="flex-start"
							marginTop={20}
							fontSize={18}
							fontWeight={500}
						>
							<Text
								color="blue.500"
								borderBottomWidth={2}
								borderBottomColor="blue.500"
							>
								{classifSelect.nome} - {devices.length}
							</Text>
						</Flex>

						{/* PRODUTOS */}
						{searchProducts.length > 0 ? (
							<SimpleGrid
								columns={[1, 1, 1, 2]}
								spacingX='6'
								spacingY='6'
								marginTop={2}
								justifyContent="center"
							>
								{searchProducts?.map(product => {
									return (
										<Item
											key={product.cod_pro}
											produto={product}
											setIsNewItemModal={setIsOpenModalItem}
											setProdutoItemModal={setProdutoItemModal}
											setIsAddNewItem={setIsAddNewItem}
										/>
									)
								})}
							</SimpleGrid>
						) : (
							<Flex
								flex="1"
								w="100vh"
								justifyContent="center"
								alignItems="center"
							>
								<Text
									color="gray.400"
									fontWeight={500}
									textAlign="center"
								>
									Nenhum produto encontrado.
								</Text>
							</Flex>
						)}
					</Flex>
				)}

				<Cart
					isOpen={isOpenCart}
					onRequestClose={setIsOpenCart}
				/>

				{isOpenModalItem && (
					<ModalItem
						isOpen={isOpenModalItem}
						onRequestClose={setIsOpenModalItem}
						produto={produtoItemModal}
						incluir={isAddNewItem}
					/>
				)}
			</Flex>
		</>
	)
}

export default Produtos;
